// Module
var code = "<h2 class=\"heading--isInteriorPageSubHeading\"> Explore Student Loan Repayment Options </h2> <p>Convenient, flexible options make it easy to repay your student loan.</p> ";
// Exports
export default code;